import { SearchSelectInput } from '@dx-ui/dx-common';
import { get } from 'lodash';
import { FieldComponentProps } from './FieldComponentProps';
import FieldWrapper from './FieldWrapper';

/**
 * Renders a SearchSelectInput
 */
const SearchSelectInputField = (props: FieldComponentProps) => {
  const { field, selectValues } = props;

  const options = field.options;

  let valueField: string = options?.optionValue || 'id';
  let nameField: string = options?.optionText ?? valueField;
  const numberToDisplaySearch = options?.numberToDisplaySearch || 2;

  // select items
  const choices = field.source ? get(selectValues, field.source) || [] : [];

  const sanitizeProps: any = ({ withConfirm, enableIfValid, ...rest }): any =>
    rest;

  return (
    <FieldWrapper {...props}>
      {(fieldProps) => (
        <SearchSelectInput
          {...sanitizeProps(fieldProps)}
          optionText={nameField}
          optionValue={valueField}
          options={choices}
          numberToDisplaySearch={numberToDisplaySearch}
          titleSuffix={field?.businessTerms}
        />
      )}
    </FieldWrapper>
  );
};

export default SearchSelectInputField;
